module.exports = __webpack_public_path__ + "media/images/close-c4c396d3afb908f878b4835a616ba1af.svg";